module.exports = __webpack_public_path__ + "static/media/court-in-the-act-tile.eff95a2d.jpg";